import { Box, Link, Typography } from '@mui/material';

import { ENTITY_PREFIX } from '../../../../../constants';
import { formatEntityId } from '../../../../../helpers';
import { IN_PROGRESS_LINK_SX, IN_PROGRESS_NOTICE_SX } from '../styles';

import type { InProgressPlanNoticeProps } from './types';

export default function InProgressPlanNotice({
  inProgressTpId,
  onPlanClick,
}: InProgressPlanNoticeProps) {
  const handlePlanClick = () => onPlanClick(inProgressTpId);

  return (
    <Box sx={IN_PROGRESS_NOTICE_SX}>
      <Typography display="inline" fontWeight={500}>
        Please conclude in-progress treatment plan{' '}
      </Typography>
      <Link component="button" type="button" sx={IN_PROGRESS_LINK_SX} onClick={handlePlanClick}>
        {formatEntityId(inProgressTpId, ENTITY_PREFIX.TreatmentPlan)}
      </Link>
      <Typography display="inline" fontWeight={500}>
        {' '}
        before cloning.
      </Typography>
    </Box>
  );
}
